export default __webpack_public_path__ + "static/media/icon_introduction.fb26742c.jpg";